import { Alert, Button, Stack } from "@mui/material";
import { useStaleBuild, useStaleServerVersion } from "../api/build-version";
import { SnoozeButton, useBannerSnoozed } from "./banner-snooze";

export const NewVersionBanner: React.FC = () => {
	const stale = useStaleBuild();
	// Per deploy: snoozing one new version does not hide the next.
	const bannerKey = `new-version:${useStaleServerVersion()}`;
	const snoozed = useBannerSnoozed(bannerKey);
	if (!stale || snoozed) return null;

	return (
		<Alert
			severity="warning"
			data-component="new-version-banner"
			action={
				<Stack direction="row" spacing={1} data-component="new-version-actions">
					<Button
						color="inherit"
						size="small"
						onClick={() => window.location.reload()}
						data-component="new-version-reload-button"
					>
						Reload
					</Button>
					<SnoozeButton bannerKey={bannerKey} />
				</Stack>
			}
		>
			A new version of the app is available. Reload when convenient to apply it.
		</Alert>
	);
};
